module.exports = __webpack_public_path__ + "img/Bernhard.e464d420.png";